export default __webpack_public_path__ + "static/media/Ingrid.44226696.png";